import { Form, Input } from "antd";
import WrappingModal from "../../../components/Modals/WrappingModal";

interface Props {
  form: any;
  colors: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
}

const FormModal = ({
  form,
  colors,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
}: Props) => {
  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل لون" : "إضافة لون"}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleOk}
        initialValues={initialValues}
        className="grid grid-cols-1 gap-3"
      >
        {/* In edit mode, display the ColorID as disabled */}
        {isEditing && (
          <Form.Item
            name="ColorID"
            label="كود اللون"
            rules={[{ required: true }]}
          >
            <Input disabled />
          </Form.Item>
        )}

        {/* Color Name */}
        <Form.Item
          name="ColorName"
          label="اسم اللون"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
